// extracted by mini-css-extract-plugin
module.exports = {"root":"CouponDataRow_root__mmlD7","title":"CouponDataRow_title__F7mEU","value":"CouponDataRow_value__GP3ht"};